import feminicidioImage from '../../../assets/img/artigos/feminicidio_icon.svg';
import mariaDaPenhaImage from '../../../assets/img/artigos/maria_da_penha_icon.svg';
import atendimentoPublicoImage from '../../../assets/img/artigos/atendimento_pulico_icon.svg';
import planoNacionalImage from '../../../assets/img/artigos/plano_nacional_icon.svg';

const lawArticlesData = [
  {
    // C7
    id: 'feminicidio',
    href: '/artigos/feminicidio',
    title: 'Feminicídio',
    type: 'Legislação',
    image: feminicidioImage,
    iconRef: 'feminicidio',
    text: (
      <>
        <p>
          Feminicídio é o termo utilizado para descrever o assassinato de mulheres por questões de
          gênero, ou seja, quando uma mulher é morta por ser mulher. Esse tipo de crime é
          caracterizado pelo ódio, desprezo ou discriminação contra o gênero feminino e,
          frequentemente, ocorre em contextos de violência doméstica, familiar ou de relações
          íntimas, mas pode também acontecer em outros contextos, como em ataques misóginos e crimes
          sexuais.
        </p>
        <p>
          O feminicídio vai além do homicídio comum, pois envolve a desigualdade de gênero como um
          fator motivador. É uma forma extrema de violência contra a mulher e, em muitos casos, está
          associada a situações de abuso prévio, controle, dominação e a uma visão de que as
          mulheres são propriedades ou que devem subordinação aos homens.
        </p>
        <p>
          No Brasil, o feminicídio foi tipificado como crime hediondo em 2015, com a Lei nº 13.104,
          que alterou o Código Penal para incluir o feminicídio como uma circunstância qualificadora
          do homicídio, com penas mais severas. Essa legislação também reconhece a necessidade de
          uma abordagem específica para lidar com a violência de gênero e busca aumentar a
          conscientização sobre esse tipo de crime, bem como garantir maior proteção às mulheres.
        </p>
        <p>
          De acordo com o Atlas da Violência 2024, cerca de 50 mil mulheres foram assassinadas entre
          2012 e 2024. A maioria das agressões (144.285) acontecem no âmbito familia. Esses dados
          revelam a sombria realidade brasileira de extrema violência contra mulheres.
        </p>
        <p>
          A respeito disso, o Brasil ocupa o 5° lugar no ranking mundial em número de mortes
          violentas de mulheres.
        </p>
        <p>
          A estatística de que a maioria das agressões (144.285) ocorre no âmbito familiar revelam
          que a violência doméstica é uma das principais formas de violência contra as mulheres no
          Brasil. Isso demonstra que o lar, que deveria ser um espaço de segurança, muitas vezes se
          torna um local de perigo para muitas mulheres.
        </p>
        <p>
          Esse contexto de violência familiar e feminicídio reflete falhas tanto nas políticas
          públicas quanto na implementação de medidas preventivas e protetivas. Apesar de leis como
          a Lei Maria da Penha, que visa proteger as mulheres da violência doméstica, a realidade
          mostra que ainda há muito a ser feito para garantir a segurança das mulheres no país.
          Fatores como a falta de apoio adequado às vítimas, falhas no sistema de justiça criminal e
          a persistência de estereótipos de gênero contribuem para a continuidade dessa violência.
        </p>
        <p>
          Além disso, o feminicídio é uma manifestação extrema de uma cultura de violência contra a
          mulher que se manifesta de várias maneiras, desde a violência verbal e psicológica até a
          violência física e sexual. A resposta eficaz a esse problema requer uma abordagem
          multifacetada, que inclua educação para a igualdade de gênero, fortalecimento das
          políticas de proteção às mulheres, e uma mudança cultural profunda que desafie e desfaça
          as normas que perpetuam a violência de gênero.
        </p>
        <p>
          Portanto, os dados do Atlas da Violência 2024 são um alerta urgente para a sociedade
          brasileira. Eles apontam para a necessidade de uma ação concertada, tanto do governo
          quanto da sociedade civil, para combater o feminicídio e garantir que todas as mulheres
          possam viver livres de violência.
        </p>
      </>
    ),
  },
  {
    // C8
    id: 'maria-da-penha',
    href: '/artigos/maria-da-penha',
    title: 'Maria da Penha',
    type: 'Legislação',
    image: mariaDaPenhaImage,
    iconRef: 'mariaDaPenha',
    text: (
      <>
        <p>
          A Lei Maria da Penha tornou mais rigorosa a punição para agressões contra a mulher quando
          ocorridas no âmbito doméstico e familiar. A referida lei entrou em vigor no Brasil no dia
          22 de setembro de 2006, sendo assim nomeada em homenagem a Maria da Penha Maia, que foi
          agredida pelo marido durante muitos anos e, em razão das agressões, tornou-se paraplégica,
          depois de sofrer atentado com arma de fogo, em 1983.
        </p>
        <p>
          A referida lei trouxe um maior respaldo do Estado às mulheres vítimas de violência e no
          seu texto é capaz de se encontrar a diferenciação entre os tipos de violência, que podem
          ser física, psicológica, patrimonial, sexual e moral, além de dispor sobre as medidas
          protetivas de urgência para tutelar a vida das mulheres, como se vê no link a seguir:
          <br />
          <b>
            <a href="https://www.planalto.gov.br/ccivil_03/_Ato2004-2006/2006/Lei/L11340.htm">
              Lei Maria da Penha
            </a>
          </b>
          <p>
            Quando se fala em violência contra a mulher, um dos primeiros pensamentos que surge na
            nossa cabeça é sobre a tão conhecida Lei Maria da Penha. Independentemente da classe
            social ou gênero, muitas pessoas já ouviram falar sobre a Lei Maria da Penha e a
            proteção que ela traz para as mulheres. Mas por que a Maria da Penha foi tão importante
            assim?{' '}
            <b>
              Por que o caso da Maria da Penha tomou proporções internacionais e como isso
              aconteceu?
            </b>
          </p>
          <p>
            Maria da Penha é uma mulher natural de Fortaleza, no Ceará, filha de um
            cirurgião-dentista e de uma professora. Ela se formou em Farmácia na Universidade
            Federal do Ceará e fez mestrado na Universidade de São Paulo, onde conheceu seu futuro
            marido (e agressor), Marco Antônio Heredia Viveros, bolsista recém-chegado da Colômbia.
          </p>
          <p>
            Ela sofreu duas tentativas de homicídio por parte de seu marido, que a deixou
            paraplégica. Após anos de impunidade, seu caso foi levado à Comissão Interamericana de
            Direitos Humanos - CIDH da OEA, que reconheceu a negligência e omissão do Estado
            Brasileiro na proteção das vítimas de VIOLÊNCIA DOMÉSTICA.
          </p>
          <p>
            A pressão internacional e os movimentos feministas internos impulsionaram a criação de
            uma lei específica.
          </p>
          <p>
            A Lei Maria da Penha foi promulgada para coibir e prevenir a violência doméstica , sendo
            responsável pela criação das medidas protetivas de urgência, bem como dos juizados de
            violência doméstica contra a mulher e estabeleceu penas mais rigorosas para os
            agressores. Além disso, trouxe outros avanços significativos, como a criação de
            delegacias especializadas e de campanhas de conscientização. É considerada uma das uma
            das três melhores legislações do mundo no enfrentamento à violência contra as mulheres.
            A Lei Maria da Penha é uma conquista histórica na afirmação dos direitos humanos das
            mulheres.
          </p>
          <p>
            Destacam-se sete inovações extraordinárias introduzidas pela Lei Maria da Penha: mudança
            de paradigma no enfrentamento da violência contra a mulher; incorporação da perspectiva
            de gênero para tratar da desigualdade e da violência contra a mulher; incorporação da
            ótica preventiva, integrada e multidisciplinar; fortalecimento da ótica repressiva;
            harmonização com a Convenção CEDAW/ONU e com a Convenção Interamericana para Prevenir,
            Punir e Erradicar a Violência contra a Mulher; consolidação de um conceito ampliado de
            família e visibilidade ao direito à livre orientação sexual; e, ainda, estímulo à
            criação de bancos de dados e estatísticas.
          </p>
          <p>
            Hoje, pela lei, configura violência doméstica e familiar contra a mulher qualquer ação
            ou omissão baseada no gênero que lhe cause morte, lesão, sofrimento físico, sexual ou
            psicológico, e dano moral ou patrimonial no âmbito da unidade doméstica, da família ou
            em qualquer relação íntima de afeto.
          </p>
          <p>
            Ressaltamos que não necessita de coabitação, ou seja, a vítima não precisa morar com o
            agressor para que o crime seja configurado.
          </p>
          <p>
            Além de a violência ter por base uma questão de gênero, para que a Lei Maria da Penha
            tenha incidência, a ação ou omissão deve ocorrer no âmbito da unidade doméstica, no
            âmbito da família ou em relação íntima de afeto, na qual o agressor conviva ou tenha
            convivido com a ofendida, independentemente de coabitação.
          </p>
          <p>Veja abaixo os tipos de violência contra a mulher previstos na Lei Maria da Penha:</p>
          <p>
            <b>I. Violência física </b>
          </p>
          <p>Qualquer conduta que ofenda sua integridade ou saúde corporal.</p>
          <p>
            <b>II. Violência psicológica </b>
          </p>
          <p>
            Complexa, normalmente está em todos os casos de violência doméstica. Antes da agressão
            física é comum ocorrer a psicológica e são agressões frequentes, diárias, que causam
            dano emocional, diminuição da autoestima, “nunca será nada sem ele”, “foram formadas por
            ele”, “ninguém vai querer ela”, fala isso com frequência para diminuir a autoestima.
          </p>
          <p>
            Casos de homens extremamente controladores, perseguem, controlam pelo GPS, querem saber
            toda hora o que elas estão fazendo, onde estão e com quem estão. E muitas mulheres não
            conhecem a violência psicológica como uma forma de violência doméstica.
          </p>
          <p>
            <b>III. Violência sexual</b>
          </p>
          <p>
            Condutas que invadem a liberdade sexual da vítima, fazendo com que ela exerça ou não
            exerça qualquer ato de sexualidade que ela não queira, que limite sua liberdade sobre
            métodos contraceptivos ou que imponha uma gravidez, tudo que limite a mulher a decidir
            sobre seu corpo ou sobre sua sexualidade.
          </p>
          <p>
            Importante lembrar que existe violência sexual e estupro em relacionamentos amorosos,
            basta que não haja consentimento, não existe obrigação sexual só porque o casal namora
            ou é casado.
          </p>
          <p>Imposição ou impedimento da gravidez é uma violência sexual.</p>
          <p>
            <b>IV. Violência patrimonial</b>
          </p>
          <p>
            Uma violência pouco conhecida. Qualquer conduta que configure retenção, subtração ou
            destruição parcial ou total de seus objetos. Retira o bem das mulheres. Ex: mulher que
            recebe salário e tem que entregar ao marido. Destruição dos bens no ciclo da violência.
          </p>
          <p>
            <b>V. Violência moral</b>
          </p>
          <p>
            <b>Calúnia:</b> atribuir falsamente crime. Dizem publicamente que você cometeu algo que
            é configurado como crime, mas você não cometeu. Ex: meu namorado diz publicamente que eu
            roubei joias.
          </p>
          <p>
            <b>Difamação:</b>atribuir fato negativo que não seja crime. Dizem que você fez algo que
            não é crime, mas como pode atingir sua honra e moral, como dizer que a mulher está se
            prostituindo.
          </p>
          <p>
            <b>Injúria:</b> atribuir palavras ou qualidades negativas, xingar.
          </p>
        </p>
        <h3>LEI MARIA DA PENHA E FORMAS DE VIOLÊNCIA CONTRA A MULHER</h3>
        <p>Como ocorre, na maioria das vezes, a violência doméstica?</p>
        <p>
          <b>Tensão:</b> Primeiro ocorre um momento de tensão, onde há predomínio de violência
          psicológica, comportamento controlador, tenta afastar a vítima do seu ciclo social, comum
          que a violência vá aumentando gradativamente. Tem ciúmes exacerbado em determinado
          momento, o casal briga e de repente pode ser que ele quebre um objeto pessoal dela,
          chegando na fase da explosão;
        </p>
        <p>
          <b>Explosão:</b> Discussão mais grave, em termos de consequências também, na qual o
          agressor usa de violência física mais severa, é nesse momento que as mulheres se sentem
          mais encorajadas para buscar ajuda. Pode ser que ocorra agressão, logo após vem a lua de
          mel;
        </p>
        <p>
          <b>Lua-de-mel:</b> &quot;Arrependimento&quot; do agressor, ele promete mudanças, se
          &quot;transforma&quot;, fica mais calmo, mais carinhoso, mas não perdura e aos poucos a
          violência é retomada. O comportamento é exacerbado: o agressor passa a ser muito
          carinhoso, muito amoroso, e a vítima começa a se perguntar se não deve dar uma chance. O
          agressor diz que se arrepende, diz que a ama, diz que não vai mais acontecer, pode até
          comprar presentes. E aí ela perdoa, acreditando em desculpas como “ah ele estava bêbado”,
          “ah ele é estressado mesmo e explosivo, mas nunca vai me fazer mal”.
        </p>
      </>
    ),
  },
  {
    // C9
    id: 'atendimento-publico',
    href: '/artigos/atendimento-publico',
    title: 'Atendimento público específico e especializado no SUS',
    type: 'Legislação',
    image: atendimentoPublicoImage,
    iconRef: 'atendimentoPublico',
    text: (
      <>
        <p>
          O atendimento especializado para mulheres e vítimas de violência doméstica e sexual
          tornou-se um dos princípios do Sistema Único de Saúde (SUS) de forma a garantir, entre
          outros direitos, o acompanhamento psicológico e cirurgias plásticas reparadoras, se for o
          caso, como se pode ver em maiores detalhes a seguir:
        </p>
        <p>
          <b>
            <a href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2017/lei/L13427.htm">
              Lei 13.427/2017
            </a>
          </b>
        </p>
        <br />
        <p>
          <b>Contatos:</b>
        </p>
        <p>
          <b>UPA VILA VELHA: </b>
          Rua L com Rua G, s/n - Vila Velha
        </p>
        <p>
          <b>UPA CRISTO REDENTOR: </b>
          Av. Presidente Castelo Branco com a Rua Alves de Lima. Telefone: 3284-2321
        </p>
        <p>
          <b>UPA BOM JARDIM: </b>
          Rua João Gentil com Av. Sgt. João Pinheiro. Telefone: 3245-8339
        </p>
        <p>
          <b>UPA ITAPERI: </b>
          Rua Betel, s/n (próximo da UECE Campus Itaperi) - Telefone: 8970-5379
        </p>
        <p>
          <b>UPA JANGURUSSU: </b>
          Av. Contorno Sul, s/n, com Av Castelo de Castro. Telefone: 3269-7028 / 3269-7421
        </p>
        <p>
          <b>UPA EDSON QUEIROZ – DENDÊ: </b>
          Rua do Contorno, no Bairro Edson Queiroz.
        </p>
        <br />
        <p>OUTRAS REDES DE ATENDIMENTOS ÀS VÍTIMAS:</p>
        <p>
          <b>CASA DA MULHER BRASILEIRA</b>
        </p>
        <p>(85) 99992-0938/99108-6538/987408668/3108-2992/3108-2931 </p>
        <p>E-mail: casadamulherbrasileira@sps.ce.gov.br </p>
        <p>casamulherbrasileira@gmail.com </p>
        <p>
          <b>Instituto Maria da Penha - IMP </b>
        </p>
        <p>Rua: Tereza Cristina, 1375 – Centro Fortaleza-Ceará - Cep.: 60.015-141 </p>
        <p>Fone: 4102-5429</p>
        <p>E-mail: atendimento@institutomariadapenha.org.br</p>
        <p>
          <b>
            Rede de Apoio a Mulher – APAVV - Associação dos Parentes e Amigos de Vítimas de
            Violência
          </b>
        </p>
        <p>
          Rua: Vicente de Castro Filho, 1705 – Engenheiro Luciano Cavalcante(sem sede própria)
          Fortaleza-Ceará - Cep.: 60.813-540
        </p>
        <p>Fones: 99969-5532/ 99284-0505</p>
        <p>
          <b>Coordenadoria Especial de Políticas Públicas para a Mulher (CEPAM-CE)</b>
        </p>
        <p>Rua: Silva Paulet, 334 - Meireles Fortaleza-CE Cep.: 60120-020 </p>
        <p>Fone: (85) 3133-3723/ 3133-3724</p>
        <p>E-mail: cepamce@gmail.com</p>
        <p>
          <b>Centro Estadual de Referência e Apoio à Mulher (CERAM)</b>
        </p>
        <p>Telefone: (85) 3108.2966</p>
        <p>Celular: (85) 9 9935.5102</p>
        <p>E-mail: ceram@sps.ce.gov.br</p>
        <p>
          <b>
            Centro de Referência e Atendimento à Mulher em Situação de Violência doméstica e sexual
          </b>
        </p>
        <p>
          Francisca Clotilde de Fortaleza Rua Padre Francisco Pinto, n° 363 – Benfica CEP:
          60.020-290 – Fortaleza – CE
        </p>
        <p>Fone: (85) 3214.5883/3105.3516</p>
        <p>E-mail: crmulherfranciscaclotilde@yahoo.com.br</p>
        <p>Coordenadora: Roberta Lopes de Souza</p>
        <p>
          <b>Centro de Convivência Madre Regina</b>
        </p>
        <p>Rua: Tenente Marques, 131 – Presidente Kennedy Fortaleza-CE - 60656-150</p>
        <p>Fone: (85) 3478-2707/ 3481-3136</p>
        <p>E-mail: ccmr@velox.com.br</p>
        <p>Gerente Executiva: Edléa Fontoura </p>
        <p>
          <b>Centro Socorro Abreu</b>
        </p>
        <p>Rua Dr. Almeida Filho, 326 – Bairro Ellery Fortaleza – CE – CEP: 60320-610</p>
        <p>Contato: (85) 3283-6363 / 3281-2065</p>
        <p>E-mail: ceram@sps.ce.gov.br</p>
        <p>
          <b>Pastoral da Mulher Marginalizada</b>
        </p>
        <p>Rua Pero Coelho, 316 - Centro CEP: 60.110-100 – Fortaleza – CE</p>
        <p>Fone: (85) 3253-7119</p>
        <p>Coordenadora: Maria das Graças Alves</p>
        <p>
          <b>Bemfam -Bem Estar Familiar no Brasil - BEMFAM</b>
        </p>
        <p>Rua Barão do Rio Branco, 1985 – Centro Fortaleza – CE – CEP: 60025–062</p>
        <p>Contato: (85) 3252 – 5072</p>
        <p>
          <b>Bemfam -Bem Estar Familiar no Brasil - BEMFAM</b>
        </p>
        <p>Rua Barão do Rio Branco, 1985 – Centro Fortaleza – CE – CEP: 60025–062</p>
        <p>Contato: (85) 3252 – 5072</p>
        <br />
        <p>
          <b>CASAS ABRIGOS</b>
        </p>
        <p>Casa Margarida Alves (endereço sigiloso) </p>
        <p>Casa do Caminho (endereço sigiloso)</p>
        <br />
        <p>
          <b>SERVIÇO DE REFERÊNCIA PARA ATENDIMENTO À MULHER VÍTIMA DE VIOLÊNCIA SEXUAL</b>
        </p>
        <p>Maternidade Escola Assis Chateaubriand Fortaleza/CE</p>
        <p>Tel.: (85) 3281-1900, ramal 2269 / 3243-1928</p>
        <p>
          <b>Hospital Geral Dr. César Cals</b>
        </p>
        <p>Fortaleza/CE</p>
        <p>Tel.: (85) 3488-2624 / 3488-2608 hgcc@trunet-ce.com.br</p>
      </>
    ),
  },
  {
    // C10
    id: 'plano-nacional',
    href: '/artigos/plano-nacional',
    title: 'Plano Nacional de Enfrentamento ao Feminicídio',
    type: 'Legislação',
    image: planoNacionalImage,
    iconRef: 'planoNacional',
    text: (
      <>
        <p>
          O Pacto Nacional de Prevenção aos Feminicídios, instituído em 16 de agosto de 2023 pelo
          Decreto nº 11.640/2023 tem o propósito de prevenir todas as formas de discriminações,
          misoginia e violências de gênero contra as mulheres por meio de ações governamentais
          intersetoriais, com perspectiva de gênero e suas interseccionalidades.
        </p>
        <p>
          De acordo com o Ministério das Mulheres, o novo pacto vai ajudar a organizar e colocar em
          prática os objetivos e princípios da Política Nacional de Enfrentamento à Violência contra
          as Mulheres. Várias áreas do Governo Federal estarão envolvidas, e o pacto pode ser
          aderido pelo Distrito Federal, estados, municípios e toda a sociedade.
        </p>
        <p>
          O Plano de Ação lançado em março de 2024 é apenas um começo e não cobre todas as medidas
          para combater discriminações e violências contra mulheres e meninas. Novos projetos
          poderão ser adicionados a cada ano.
        </p>
      </>
    ),
  },
];

export default lawArticlesData;
